module.exports = __webpack_public_path__ + "img/youtube-logo-o.80afecd5.svg";